import api from '../api';

export interface SupportConfig {
  enabled: boolean;
  base_url: string;
  website_token: string;
  operator_url: string;
}

export interface SupportIdentity {
  identifier: string;
  identifier_hash: string;
  name: string;
  email: string;
}

export function validSupportUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password
      && ['support.glauncher.kz', 'api.glauncher.kz'].includes(url.hostname);
  } catch { return false; }
}

export async function getSupportConfig(signal?: AbortSignal): Promise<SupportConfig> {
  const { data } = await api.get<SupportConfig>('/support/config', { signal, timeout: 10000 });
  if (!data.enabled) return data;
  if (!validSupportUrl(data.base_url) || !validSupportUrl(data.operator_url)
      || !/^[a-zA-Z0-9_-]{8,200}$/.test(data.website_token)) {
    throw Object.assign(new Error('Invalid support configuration'), { code: 'SUPPORT_CONFIG_INVALID' });
  }
  return data;
}

export async function getSupportIdentity(signal?: AbortSignal): Promise<SupportIdentity> {
  const { data } = await api.get<SupportIdentity>('/support/identity', { signal, timeout: 10000 });
  if (!/^glauncher:[a-zA-Z0-9_-]+$/.test(data.identifier)
      || !/^[a-f0-9]{64}$/i.test(data.identifier_hash) || !data.name || !data.email) {
    throw new Error('Invalid support identity');
  }
  return data;
}

export const openSupportChat = () => window.dispatchEvent(new Event('gl:open-support'));
